

















import { Component, Vue } from 'vue-property-decorator';

import BasicButton from '@/ui-components/BasicButton.vue';
import FreemiumFilterBadge from '@/components/filter-bar/FreemiumFilterBadge.vue';
import FreemiumIcon from '@/components/modals/freemium/FreemiumIcon.vue';
import { ModalHelper } from '@/helpers/modal-helper';
import { ProModal } from '@/lazy-load-components';
import { saveLastProView } from '@/helpers/pro-web-helper';

@Component({
	name: 'NewProBanner',
	components: {
		BasicButton,
		FreemiumFilterBadge,
		FreemiumIcon,
	},
})
export default class NewProBanner extends Vue {
	get logoSrc() {
		return `/${ASSETS_DIR}/img/logo/JustWatch-logo-small.png`;
	}

	openProModal() {
		ModalHelper.openModal(
			ProModal,
			{
				locationOverride: 'NewTimeline',
			},
			{},
			'NewTimeline',
			true
		);

		saveLastProView('NewTimeline');
	}
}
